import React, { useState, useEffect } from 'react';
import './GlobalGuestTimer.css'; // 스타일 파일 별도 분리

const GlobalGuestTimer = ({ expireAt, onExpired }) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!expireAt) return;

    const interval = setInterval(() => {
      const now = new Date();
      const end = new Date(expireAt);
      const diff = end - now;

      // 시간이 다 되면?
      if (diff <= 0) {
        setTimeLeft("00:00:00");
        clearInterval(interval);
        if (onExpired) onExpired(); // 만료 시 실행할 콜백 (새로고침 등)
        return;
      }

      // 시간 포맷팅 (HH:MM:SS)
      const h = Math.floor(diff / (1000 * 60 * 60));
      const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((diff % (1000 * 60)) / 1000);

      const hString = h > 0 ? `${h}:` : ''; 
      const mString = m.toString().padStart(2, '0');
      const sString = s.toString().padStart(2, '0');

      setTimeLeft(`${hString}${mString}:${sString}`);
    }, 1000);

    return () => clearInterval(interval);
  }, [expireAt, onExpired]);

  if (!timeLeft) return null;

  return (
    <div className="global-timer-bar">
      <span>⏳ <strong>{timeLeft}</strong> 후 데이터가 초기화 됩니다.</span>
    </div>
  );
};

export default GlobalGuestTimer;